import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import Logo from "@/components/layout/Logo";
import type { LogoProps } from "./Header.props";
interface HeaderLogoProps {
  logo?: LogoProps;
  isTransparent: boolean;
}
export const HeaderLogo = t0 => {
  const $ = _c(6);
  const {
    logo,
    isTransparent
  } = t0;
  const t1 = logo?.href || "/";
  let t2;
  if ($[0] !== isTransparent || $[1] !== logo) {
    t2 = logo?.src ? <Image src={logo.src} alt={logo.alt || "AgencyQ Logo"} className="h-10 w-auto" width={160} height={40} /> : <Logo variant={isTransparent ? "light" : "default"} />;
    $[0] = isTransparent;
    $[1] = logo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <Link href={t1} className="flex shrink-0 items-center gap-2 transition-transform duration-150 hover:scale-102" aria-label="AgencyQ Home">{t2}</Link>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};